import React, {useEffect} from 'react';
function AnchorBlock({
    children,
    blockName,
    blockId,
    refs,
    ...props
}) {
    useEffect(() => {
        
        const pageHeight = window.innerHeight;
        const observerMargin = Math.floor(pageHeight / 2);
        const observerConfig = {
            root: null,
            rootMargin: `-${pageHeight % 2 === 0 ? observerMargin - 1 : observerMargin}px 0px -${observerMargin}px 0px`,
            threshold: 0
        };
        
        const handleIntersection = function(entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    var activeItems = document.querySelector('.active');
                    if(typeof(activeItems) != 'undefined' && activeItems != null){
                        activeItems.classList.remove('active');
                    }

                    var menuItem = document.querySelector('[data-anchorid="'+ entry.target.id +'"]');
                    if(typeof(menuItem) != 'undefined' && menuItem != null){
                        menuItem.classList.add('active');
                    }
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection,observerConfig);

        observer.observe(refs[blockName].current);

        return () => observer.disconnect();
        
    }, [refs, blockName]);

    return (
        <div 
            id={blockId}
            ref={refs[blockName]}>
            {children}
        </div>
    );
}

export default AnchorBlock